export default __webpack_public_path__ + "static/media/55_1_2.a14ad50c.png";